(function () {
    const calcHeightInfoBottom = (section) => {
      const cards = section.querySelectorAll(".collection-grid__item");
  
      cards.forEach((card) => {
        const bottomEl = card.querySelector(".collection-grid__info-bottom");
        if (bottomEl) {
          const height = bottomEl.scrollHeight;
          bottomEl.style.setProperty("--bottom-max-height", `${height}px`);
        }
      });
    };
  
    const initSlider = (section) => {
      const sliderEl = section.querySelector(".swiper--collection-grid");
      if (!sliderEl) return;
  
      const nextBtn = section.querySelector(
        ".heading-group__navigation-button-next"
      );
      const prevBtn = section.querySelector(
        ".heading-group__navigation-button-prev"
      );
      const itemsPerRow = Number(sliderEl.dataset.itemsPerRow || 3);
      const spaceBetween = Number(sliderEl.dataset.spaceBetween || 0);
  
      const breakpoints = {
        4: {
          576: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
        3: {
          576: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
        },
        2: {
          576: {
            slidesPerView: 2,
          },
        },
        1: {
          576: {
            slidesPerView: 1,
          },
        },
      };
  
      new Swiper(sliderEl, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: spaceBetween,
        speed: 800,
        mousewheel: {
          forceToAxis: true,
        },
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: breakpoints[itemsPerRow],
      });
    };
  
    const destroySlider = (section) => {
      const sliderEl = section.querySelector(".swiper--collection-grid");
      if (!sliderEl) return;
  
      const slides = sliderEl.querySelectorAll(".collection-grid__item");
  
      if (sliderEl.swiper) sliderEl.swiper.destroy();
  
      slides.forEach((slide) => {
        slide.removeAttribute("style");
      });
    };
  
    const initCollectionGrid = (section) => {
      if (!section || !section?.classList.contains("collection-grid-section")) {
        return;
      }
  
      const box = section.querySelector(".collections-grid");
      const layout = box?.dataset?.layout || "slider";
      const sliderEl = section.querySelector(".swiper--collection-grid");
      const infoType = box?.dataset?.infoType;
  
      if (layout === "slider") {
        if (sliderEl?.swiper) {
          destroySlider(section);
        }
        initSlider(section);
      } else {
        destroySlider(section);
      }
  
      if (infoType === "dropdown") {
        const observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            calcHeightInfoBottom(section);
          });
        });
  
        observer.observe(section);
      }
    };
  
    initCollectionGrid(document.currentScript.parentElement);
  
    document.addEventListener("shopify:section:load", function (event) {
      initCollectionGrid(event.target);
    });
  })();
  